import { useMemo } from 'react';
import { CCAsections } from "../data/mockData";

export const useFlatIndicators = () => {
    return useMemo(() => {
        const items = [];
        CCAsections.forEach((section) => {
            const outcome = section.label;
            section.indicators.forEach((indicator) => {
                const theme = indicator.label
                indicator.items.forEach((item) => {
                    items.push({
                        outcome: outcome,
                        theme: theme,
                        label: item.label,
                        value: item,
                        indicatorSlug: indicator.slug,
                        sectionValue: section.value,
                        sectionLabel: section.label,  // Add the missing section label
                        id: item.id,
                    });
                });
            });
        });
        return items;
    }, []);
};
